import app from './app';
import { USERPROFILE_SERVICE_URL, REPORT_SERVICE_URL, ORDER_SERVICE_URL } from '../../libs/constants';
import { saveAs } from 'file-saver';

//POST
const getCompanyList = (userId) => async (dispatch, getState, api) => {
    try {
        dispatch(app.setLoading(true));
        const headerConfig = {
            headers: {
                "DRS-Fetch-Type": "getCompanyList"
            }
        };
        const response = await api.post(USERPROFILE_SERVICE_URL + 'users/company/' + userId, null, headerConfig);
        dispatch(app.setLoading(false));
        dispatch({
            type: "SET_EXPORT_PARTNER_FINANCIALS_COMPANY_LIST",
            payload: response
        });
    } catch (error) {
        dispatch(app.setLoading(false));
        console.log(error);
    }
};

//POST
const getExportPartnerFinancialsList = (userId, requestData) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));
    try {
        
        const response = await api.post(ORDER_SERVICE_URL + '/partnerFinancialData/' + userId, requestData);
        dispatch(app.setLoading(false));
        dispatch({
            type: "SET_EXPORT_PARTNER_FINANCIALS_LIST",
            payload: response.data
        });
    } catch (error) {
        dispatch(app.setLoading(false));
        console.log(error);
    }
};

const setFilters = (filters) => {
    return {
        type: "SET_EXPORT_PARTNER_FINANCIALS_FILTERS",
        payload: filters
    }
}

const setIsSubmitClicked = (value) => {
    return {
        type: "SET_IS_SUBMIT_CLICKED",
        payload: value
    }
}

const setCompany = (company) => {
    return {
        type: "SET_COMPANY",
        payload: company
    }
}

//POST
const generateExportPartnerFinancials = (userId, requestData) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));
    try {
        await api.post(REPORT_SERVICE_URL + 'generate/partnerFinancialsReport/' + userId, requestData)
            .then(response => {
                dispatch(app.setLoading(false));
                dispatch({
                    type: "SET_EXPORT_PARTNER_FINANCIALS",
                    payload: response
                });

                if (response.data.includes("successfully")) {
                    const modalObject = {
                        type: "confirm",
                        messageText: "We are currently working for building your Partner Financials Report.",
                        rounded: true,
                        acceptHandler: null,
                        rejectHandler: null,
                        hideConfirmationButtons: true,
                        iconToRender: "HOURGLASS_ICON",
                        consolidatedReport: true
                    }
                    dispatch(app.setAppModal(modalObject));
                }
                else {
                    const modalObject = {
                        type: "confirm",
                        messageText: "No records found matching your criteria",
                        rounded: true,
                        acceptHandler: null,
                        rejectHandler: null,
                        hideConfirmationButtons: true,
                        iconToRender: "REJECT_RED_ICON",
                        consolidatedReport: true,
                        childComponentToRender: "Please modify your filter selection and try again."
                    }
                    dispatch(app.setAppModal(modalObject));
                }
            });
    } catch (error) {
        dispatch(app.setLoading(false));
        const modalObject = {
            type: "confirm",
            messageText: "No records found matching your criteria",
            rounded: true,
            acceptHandler: null,
            rejectHandler: null,
            hideConfirmationButtons: true,
            iconToRender: "REJECT_RED_ICON",
            consolidatedReport: true,
            childComponentToRender: "Please modify your filter selection and try again."
        }
        dispatch(app.setAppModal(modalObject));
    }
};

//POST
const getExportPartnerFinancialsDownloadList = (userId) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));
    try {
        const response = await api.post(REPORT_SERVICE_URL + 'partnerFinancialsReport/list/' + userId, null);
        dispatch(app.setLoading(false));
        dispatch({
            type: "SET_EXPORT_PARTNER_FINANCIALS_DOWNLOAD_LIST",
            payload: response
        });
    } catch (error) {
        dispatch(app.setLoading(false));
        console.log(error);
    }
};

//POST
const downloadPartnerFinancialsReportPfr = (userId,userType, reportId) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));

    let downloadConfig = {
        headers: {
            accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        },
        responseType: "blob"
    };
    await api.post(REPORT_SERVICE_URL + 'download/partnerFinancialsReport/' + userId + "/" + reportId + "?reportType=pfr", null, downloadConfig)
        .then(response => {
            dispatch(app.setLoading(false));
            saveAs(new Blob([response.data]), reportId.split("-")[0] +"_" + userType + "_PFReport.xlsx");
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            console.log(error);
        });
};


const customizedReportActions = {
    getCompanyList: getCompanyList,
    getExportPartnerFinancialsList: getExportPartnerFinancialsList,
    setFilters: setFilters,
    setIsSubmitClicked: setIsSubmitClicked,
    generateExportPartnerFinancials: generateExportPartnerFinancials,
    getExportPartnerFinancialsDownloadList: getExportPartnerFinancialsDownloadList,
    downloadPartnerFinancialsReportPfr: downloadPartnerFinancialsReportPfr,
    setCompany: setCompany
}

export default customizedReportActions;